<top-menu [showPrint]="false"></top-menu>
<command-menu
  [filterPage]="filterPage"
  [filterType]="filterType"
  [filterText]="'Filter quotes'"
  [showDottedMenu]="true"
  [showExport]="true"
  [canEditColumns]="true"
  [addItemText]="!event || event.is_readonly ? '' : '+ ADD QUOTE TO RESOURCE'"
  (addItem)="addQuoteToResource($event)"
  (onExport)="saveTable()"
></command-menu>
<nested-table
  [items]="tableData"
  [filtersId]="filterPage"
  [condensedView]="condensed"
  [columns]="columnData"
  [readOnly]="!event || event.is_readonly"
  [columnsById]="columnsById"
  [menuItems]="menuItems"
  [menuDisabled]="busy"
  [defaultSelectedColumnId]="quoteColumns.resource"
  (selectItem)="manageQuote($event)"
  (updatedSelectedIds)="selectIds($event)"
  [emptyMessage]="'No quotes in this event'"
></nested-table>
<loader-pane-fragment [trace]="traceNames.viewBudgetQuotes"></loader-pane-fragment>